














import ReviewListFilterTeam from '@/components/ReviewListFilterTeam.vue'
import EstablishmentListFilterTeam from '@/components/EstablishmentListFilterTeam.vue'
import FlowDetail from '@/components/FlowDetail.vue'


export default {
  name: 'team',
  components: {
      ReviewListFilterTeam
      EstablishmentListFilterTeam
      FlowDetail
  }
  mounted: ()->
    if @$route.params.uid?
      this.$store.dispatch("select_review", @$route.params.uid)

}
